export default __webpack_public_path__ + "static/media/njurunda-map.9b870c26.png";